export default __webpack_public_path__ + "static/media/payment.00c2776a.jpeg";